<template>
	<div>
		<h2>{{ $t('tiers.menu_supplier_articles') }}</h2>

		<div class="box">
			<CustomTable
				ref="table"
				id_table="tiers_supplier_articles"
				:items="articles"
				:busy.sync="table_busy"
				primaryKey="isarticles_id"
			/>
		</div>

		<ArticlePriceModal ref="prices" />
		<ArticleAliasesModal ref="aliases" @updated="reload" />
		<ArticleMergeModal ref="merge" @updated="reload" />
		<ArticleRenameModal ref="rename" @updated="reload" />
		<ArticleAccountModal ref="account" @updated="reload" />
	</div>
</template>

<script type="text/javascript">
	import Invoice from "@/mixins/Invoice.js"
	import Navigation from "GroomyRoot/mixins/Navigation.js"

	export default {
		name: "TiersSupplierArticles",
		mixins: [Invoice, Navigation],
		props: ['tiers_id'],
		data() {
			return {
				articles: [],
				table_busy: true,
				events_tab: {
					'TableAction::goToSupplierArticlePrices': (article) => {
						this.$refs.prices.open(article.isarticles_label, this.tiers_id)
					},
					'TableAction::goToSupplierArticleAliases': (article) => {
						this.$refs.aliases.open(article, this.tiers_id)
					},
					'TableAction::goToRenameSupplierArticle': (article) => {
						this.$refs.rename.open(article, this.tiers_id)
					},
					'TableAction::goToSupplierArticleAccount': (article) => {
						this.$refs.account.open(article, this.tiers_id)
					},
					'TableAction::goToMergeSupplierArticles': (articles) => {
						this.$refs.merge.open(articles, this.articles, this.tiers_id)
					}
				}
			}
		},
		mounted() {
			this.init_component()
		},
		methods: {
			/**
			 * Charge les articles achetés au fournisseur. L'unité et le prix sont préparés ici : le
			 * tableau rend ses cellules telles quelles, un code UN/ECE et un prix à quatre décimales s'y
			 * afficheraient en l'état.
			 */
			async init_component() {
				this.table_busy = true
				const articles = await this.getTiersSupplierArticles(this.tiers_id)
				this.articles = articles.map(article => ({
					...article,
					unit_label: this.unitLabel(article.isarticles_unit),
					last_unit_price_label: article.last_unit_price === null ? '' : article.last_unit_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 })
				}))
				this.table_busy = false
			},

			/**
			 * Recharge la liste après un déliage ou un rapprochement. La sélection est vidée : elle peut
			 * désigner un article que le rapprochement vient de supprimer, que le tableau ne retrouverait
			 * plus à l'action suivante.
			 */
			reload() {
				this.$refs.table.unselectAll()
				this.init_component()
			}
		},
		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			ArticlePriceModal: () => import('@/components/InvoiceSupplier/ArticlePriceModal'),
			ArticleAliasesModal: () => import('@/components/InvoiceSupplier/ArticleAliasesModal'),
			ArticleMergeModal: () => import('@/components/InvoiceSupplier/ArticleMergeModal'),
			ArticleRenameModal: () => import('@/components/InvoiceSupplier/ArticleRenameModal'),
			ArticleAccountModal: () => import('@/components/InvoiceSupplier/ArticleAccountModal')
		}
	}
</script>
